// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"1f431ac0","413":"0c327396","448":"76d09239","481":"23cec98c","603":"21421cf5","826":"19d66f73","969":"cbf0ef8f"}[chunkId] + ".chunk.css";
};